;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import {
  SEARCH_FILTER_IN_PERSON,
  SEARCH_FILTER_VIRTUAL,
  SEARCH_FILTER_WORKSHOP,
  SEARCH_FILTER_THERAPY_GROUP,
  SEARCH_FILTER_SUPPORT_GROUP,
  SEARCH_FILTER_RETREATS,
  SEARCH_FILTER_PROVIDER_GROUP,
  SEARCH_FILTER_THERAPISTS,
  SEARCH_FILTER_COACHES,
  SEARCH_FILTER_ALTERNATIVE,
} from "../../../../../lib/constants"
import AlternativeIcon from "../icons/AlternativeIcon"
import CoachesIcon from "../icons/CoachesIcon"
import InPersonIcon from "../icons/InPersonIcon"
import RetreatsIcon from "../icons/RetreatsIcon"
import SupportGroupIcon from "../icons/SupportGroupIcon"
import TherapyGroupIcon from "../icons/TherapyGroupIcon"
import TherapistsIcon from "../icons/TherapistsIcon"
import VirtualIcon from "../icons/VirtualIcon"
import WorkshopIcon from "../icons/WorkshopIcon"
import ClinicalPeerGroupIcon from "../icons/ClinicalPeerGroupIcon"
import { cn } from "@/lib/utils"

// Was two MUI styled(Button) variants; now one plain Tailwind button (renders
// above the fold on the home page, so kept off MUI/Emotion).
const BUTTON_BASE_CLASSES =
  "relative ml-2 flex h-[90px] w-fit shrink-0 cursor-pointer flex-col items-center justify-center rounded-[5px] p-1.5 text-center font-roboto text-[16px] leading-[19px] tracking-[0.03em] text-[#092C3C] transition-colors hover:bg-[#E0E0E0] active:cursor-grabbing"
const BUTTON_SELECTED_CLASSES = "bg-[#DADEE0] font-normal min-[800px]:min-w-[90px]"
const BUTTON_UNSELECTED_CLASSES = "bg-white font-medium min-w-[90px]"

const CONTENT_STYLE = "flex flex-col justify-center items-center"

// Inactive tint matches label (`text-[#AAA]`); active state overrides via cloneElement in getIcon.
const FILTER_ICON_INACTIVE_COLOR = "#AAA"

const SEARCH_FILTER_BUTTONS = {
  [SEARCH_FILTER_ALTERNATIVE.type]: {
    icon: <AlternativeIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_ALTERNATIVE.text,
    customStyles: { height: "40px", width: "40px" },
  },
  [SEARCH_FILTER_COACHES.type]: {
    icon: <CoachesIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_COACHES.text,
    customStyles: { top: "-5px", left: "0", height: "45px", width: "45px" },
  },
  [SEARCH_FILTER_IN_PERSON.type]: {
    icon: <InPersonIcon isGroupCard={false} color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_IN_PERSON.text,
    customStyles: { height: "25px", width: "31px" },
  },
  [SEARCH_FILTER_RETREATS.type]: {
    icon: <RetreatsIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_RETREATS.text,
    customStyles: { top: "-3px", left: "0", height: "85px", width: "85px" },
  },
  [SEARCH_FILTER_SUPPORT_GROUP.type]: {
    icon: <SupportGroupIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_SUPPORT_GROUP.text,
    customStyles: { top: "-4px", left: "1px", height: "80px", width: "80px" },
  },
  [SEARCH_FILTER_PROVIDER_GROUP.type]: {
    icon: <ClinicalPeerGroupIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_PROVIDER_GROUP.text,
    customStyles: { top: "-4px", left: "1px", height: "55px", width: "55px" },
  },
  [SEARCH_FILTER_THERAPISTS.type]: {
    icon: <TherapistsIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_THERAPISTS.text,
    customStyles: { top: "-3px", left: "0", height: "45px", width: "45px" },
  },
  [SEARCH_FILTER_THERAPY_GROUP.type]: {
    icon: <TherapyGroupIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_THERAPY_GROUP.text,
    customStyles: { top: "-4px", left: "7px", height: "85px", width: "85px" },
  },

  [SEARCH_FILTER_VIRTUAL.type]: {
    icon: <VirtualIcon isGroupCard={false} color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_VIRTUAL.text,
    customStyles: { height: "35px", width: "35px" },
  },
  [SEARCH_FILTER_WORKSHOP.type]: {
    icon: <WorkshopIcon color={FILTER_ICON_INACTIVE_COLOR} />,
    text: SEARCH_FILTER_WORKSHOP.text,
    customStyles: { top: "-4px", left: "-6px", height: "56px", width: "56px" },
  },
}

// need to figure out how to do direct look up for text and icon
export default function SearchFilterButton({ isActive, onClick, searchFilterType }) {
  const getSearchFilterButton = (property) =>
    SEARCH_FILTER_BUTTONS[searchFilterType][property]

  const renderText = () => {
    return (
      <div
        className={`${
          isActive ? `text-black` : `text-[#AAA]`
        } text-[16px] font-medium tracking-[.32px]`}
      >
        {getSearchFilterButton("text")}
      </div>
    )
  }

  const getIcon = (customStyles = {}) => {
    const iconComponent = getSearchFilterButton("icon")
    if (isActive) {
      return React.cloneElement(iconComponent, {
        style: customStyles,
        color: "black",
      })
    }
    return React.cloneElement(iconComponent, { style: customStyles })
  }

  const renderIcon = (customStyles = {}) => {
    return (
      <div className={"relative h-[40px] w-[40px] flex justify-center items-center"}>
        <div className={"relative"} style={{ ...customStyles }}>
          {getIcon(customStyles)}
        </div>
      </div>
    )
  }
  const customStyles = SEARCH_FILTER_BUTTONS[searchFilterType].customStyles || {}
  return (
    <button
      type="button"
      onClick={() => onClick()}
      className={cn(
        BUTTON_BASE_CLASSES,
        isActive ? BUTTON_SELECTED_CLASSES : BUTTON_UNSELECTED_CLASSES,
      )}
    >
      <div className={CONTENT_STYLE}>
        {renderIcon(customStyles)}
        {renderText()}
      </div>
    </button>
  )
}
